import { ROUTE_PATHS } from 'src/library/app-routes.lib';

export const APP_ROUTES = [
  {
    path: ROUTE_PATHS.PROMOTIONS,
    loadChildren: () =>
      import('./tabs/tab-promotions/tab-promotions.module').then(
        m => m.TabPromotionsPageModule
      ),
  },
  {
    path: ROUTE_PATHS.ARTICLE_DYNAMIC_PATH,
    loadChildren: () =>
      import('./tabs/tab-webview/tab-webview.module').then(
        m => m.TabWebviewPageModule
      ),
  },
  {
    path: ROUTE_PATHS.ARTICLE,
    redirectTo: ROUTE_PATHS.ARTICLE_DYNAMIC_PATH,
    pathMatch: "prefix",
  },
  {
    path: ROUTE_PATHS.GAME,
    loadChildren: () =>
      import('./tabs/tab-game/tab-game.module').then(
        m => m.TabGamePageModule
      ),
  },
  {
    path: ROUTE_PATHS.LOBBY,
    loadChildren: () =>
      import('./tabs/tab-lobby/tab-lobby.module').then(
        m => m.TabLobbyPageModule
      ),
  },
  {
    path: ROUTE_PATHS.LOBBY_DYNAMIC_PATH,
    loadChildren: () =>
      import('./tabs/tab-lobby/tab-lobby.module').then(
        m => m.TabLobbyPageModule
      ),
  },
  // {
  //   path: ROUTE_PATHS.PAGE_SELECTOR,
  //   loadChildren: () =>
  //     import('./pages/page-selector/page-selector.module').then(
  //       m => m.PageSelectorPageModule
  //     ),
  // },
  {
    path: ROUTE_PATHS.DEFAULT,
    pathMatch: 'full',
    redirectTo: ROUTE_PATHS.LOBBY,
  },
  {
    path: ROUTE_PATHS.UNKNOWN,
    redirectTo: ROUTE_PATHS.LOBBY,
  },
];